const fetchData = ({ listId }) => {
  // TODO: take care of pagination if results.length > 100
  const url = `https://api.getwemap.com/v3.0/pinpoints/search?list=${listId}&limit=100`;
  return fetch(url, { method: 'GET' }).then(response => Promise.all([response, response.json()]));
};

export { fetchData };
